import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { envConfig } from '@pff-consumer/utils'

const { GEO_DOMAIN } = envConfig

type GeoServicesResponse = {
  bettingContentEnabled: boolean
  bettingToolsEnabled: boolean
  city: string
  country: 'US' | 'UK' | 'GB'
  autoEnableMarketing: boolean
}

const ONE_DAY_IN_SECONDS = 86400
// Define a service using a base URL and expected endpoints
export const geoServicesApi = createApi({
  reducerPath: 'geoServicesApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${GEO_DOMAIN}/` }),
  endpoints: (builder) => ({
    locationFeatures: builder.query<GeoServicesResponse, void>({
      query: () => {
        return {
          url: 'betting-permissions',
          method: 'get',
          headers: {
            'Content-type': 'application/json',
          },
        }
      },
      keepUnusedDataFor: ONE_DAY_IN_SECONDS,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLocationFeaturesQuery } = geoServicesApi
